import { render, staticRenderFns } from "./ToolSlapTap.vue?vue&type=template&id=771c633a"
import script from "./ToolSlapTap.vue?vue&type=script&lang=js"
export * from "./ToolSlapTap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports